<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>ការគ្រប់គ្រងតួអង្គ</h4>
		</div>
		<div class="md-layout-item md-medium-size-50 md-size-50 text-right">
			<md-button class="md-raised md-primary" @click="$router.push('/actors/new')">បង្កើតតួអង្គថ្មី</md-button>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-15">
								<md-field>
									<label>ស្វែងរកតួអង្គតាមរយៈឈ្មោះ</label>
									<md-input v-model="search.text" type="text"
										@keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-20">
								<md-button class="md-raised md-primary" @click="searchHandler()"
									style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
						</div>
						<md-table v-if="actorList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>រូបភាព</md-table-head>
								<md-table-head>ឈ្មោះតួអង្គ</md-table-head>
								<md-table-head>សកម្មភាព</md-table-head>
							</md-table-row>

							<md-table-row v-for="(actor, index) in actorList">
								<!-- <md-table-cell></md-table-cell> -->
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<md-table-cell><img :src="config.cdn + 'images/' + actor.image_url" class="poster"></md-table-cell>
								<md-table-cell><b>{{actor.name}}</b></md-table-cell>

								<md-table-cell>
									<router-link :to="'actors/edit/' + actor.hash">
										<md-button class="md-just-icon md-simple md-primary">
											<md-icon>edit</md-icon>
											<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
										</md-button>
									</router-link>
									<md-button class="md-just-icon md-simple md-danger" @click="onDelete(actor.hash)">
										<md-icon>delete</md-icon>
										<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
									</md-button>
								</md-table-cell>
							</md-table-row>
						</md-table>
						<h5 class="text-center" v-if="actorList.length == 0 && loaded == true">មិនមានតួអង្គ</h5>
						<div class="text-right" v-if="loadMore">
							<md-button class="md-primary"
								@click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
						</div>
					</div>

					<md-dialog-confirm :md-active.sync="deleteDialogActive" :md-title="'លុបតួអង្គនេះចេញ ?'"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDelete" />
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				deleteDialogActive: false, deleteSelected: '',
				search: { text: "" },
				loadMore: false,
				actorList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				let size = 50;
				this.$http.post(this.config.api + "/user/actor/search", {
					text: this.search.text,
					size: size,
					offset: more ? this.actorList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == size) this.loadMore = true;
					else this.loadMore = false;
					this.actorList = more ? this.actorList.concat(data.body.data) : data.body.data;
				})
			},
			onDelete(hash) {

				if (this.deleteSelected == "") {
					this.deleteDialogActive = true;
					this.deleteSelected = hash;
					return;
				}

				this.$http.post(this.config.api + "/user/actor/delete", {
					hash: this.deleteSelected
				}).then(res => {
					this.onCancel();
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "អ្នកបានលុបតួអង្គនេះដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.poster {
		height: 70px;
		width: auto;
	}

	.cover {
		height: 70px;
		width: auto;
		margin-left: 10px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Actors/View.vue